export default function  PCMeeting() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePCMeeting">
            <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/october-12-icon.png" alt="October 12 Calendar Icon" />
            <b>CANCELED: Planning Commission Meeting &nbsp;&nbsp;&nbsp;&nbsp;
             </b>
            {/*   <span className="badge bg-danger">MEETING</span> */}
             <span className="badge bg-danger">CANCELED</span> 
            </div>
          </button>
        </h2>
        <div id="collapsePCMeeting" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
          <div className="accordion-body">
          <p>
              <strong>THIS MEETING HAS BEEN CANCELED</strong><br/> 
            {/*
             Monday, August 10, 2026 at 7:00 p.m. <br />
           
            <a href="https://maps.app.goo.gl/uB7NMgLow9j2wTka6">
              <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall (35 Union St.)
            </a>
*/}
            
            
          </p>
          </div>
        </div>
      </div>
    )
}